<template>
  <el-card>
    <div slot="header" class="header">
      <span data-test-main-header >Build your text based question</span>
      <el-button data-test-cancel-button class="trash" type="text" @click.stop="cancel">
        Cancel
      </el-button>
    </div>
    <el-form @submit.native.prevent>
      <el-form-item>
        <label data-test-question-label>What is the question you want to ask?</label>
        <el-input data-test-question-input placeholder="Question" v-model="label" :disabled="field ? true : false" />
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-switch data-test-required-switch v-model="required" active-text="Required" />
      <el-button data-test-save-button type="primary" size="small" @click.stop="commit" :disabled="!label">Save</el-button>
    </div>
  </el-card>
</template>
<script>
  import EventBus from '@/event-bus';

  export default {
    props: ['field'],
    data() {
      return {
        required: this.field ? this.field.required : false,
        label: this.field ? this.field.label : '',
      };
    },
    methods: {
      cancel() {
        EventBus.$emit('field.cancel');
      },
      commit() {
        if (!this.label) {
          return;
        }

        const payload = {
          type: 'text',
          label: this.label,
          required: this.required,
        };

        if (this.field) {
          payload.fieldIndex = this.field.fieldIndex;
        }

        EventBus.$emit('field.commit', payload);
      },
    },
  };
</script>
<style lang="scss" scoped>
  .header {
    font-weight: 700;
    color: #00152a;
  }

  .trash {
    float: right;
    color: #afbcca;
    padding: .25rem 0;
  }

  .footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid var(--xpl-color-gray-400);
    padding-top: 1rem;
  }
</style>
